import AbstractContext from "../shared/AbstractContext";
import portalConfiguration from "../shared/configuration/PortalConfiguration";
import OAuthSession from "./session/OAuthSession";

export default class OAuthContext extends AbstractContext<OAuthContext, OAuthSession> {
	public async initialize() {
		this._session = new OAuthSession(portalConfiguration.baseUrl, this);

		try {
			await this._session.initialize();
			this._initialized = true;
		} catch (exception: any) {
			// can be ignored, Errors are already handled
		}
	}
}